import React, { Fragment } from 'react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Form, Header, Segment } from 'semantic-ui-react';
import { fetchLanguages, fetchDocumentTypes, fetchCertificateReasons, fetchDocumentTemplates, fetchDocumentStatuses } from '../Lookups/util';
import { extractFileNameFromHeaders } from '../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class GetCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            documentLanguages: [],
            language: '',
            documentType: '',
            certificateReason: '',
            docLanguages: [],
            loader: true,
            documentTypeError: false,
            certificateReasonIdError: false,
            loading: false,

            languages: [],
            documentTypes: [],
            certificateReasons: [],
            documentTemplates: [],
            documentStatuses: []
        };
        this.sendDocumentRequest = this.sendDocumentRequest.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getDocTemplateIdFromDocTypeId = this.getDocTemplateIdFromDocTypeId.bind(this);
        this.getStatusCertificateId = this.getStatusCertificateId.bind(this);
        this.getWithdrawalForm = this.getWithdrawalForm.bind(this);
        this.graduationCerificate = this.graduationCerificate.bind(this);
        this.processRequest = this.processRequest.bind(this);
        this.processed = this.processed.bind(this);
    }

    componentDidMount() {
        this.setState({
            language: 1,
            documentLanguages: [
                {
                    text: window.$locale === 'en' ? 'B/H/S language' : 'B/H/S jezik',
                    key: 1,
                    value: 1
                },
                {
                    text: window.$locale === 'en' ? 'English language' : 'Engleski jezik',
                    key: 2,
                    value: 2
                },
            ]
        });

        axios.all([fetchLanguages(), fetchDocumentTypes(), fetchCertificateReasons(), fetchDocumentTemplates(), fetchDocumentStatuses()])
            .then(axios.spread((languagesRes, documentTypeRes, certificateReasonRes, documentTemplatesRes, documentStatusRes) => {
                const languages = languagesRes.data;
                const documentTypes = documentTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                const certificateReasons = certificateReasonRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale)
                        ? el.translations.find(e => e.language === window.$locale).name : el.name : el.name)
                }));
                const documentStatuses = documentStatusRes.data;
                const documentTemplates = documentTemplatesRes.data;
                this.setState({
                    languages,
                    documentTypes,
                    certificateReasons,
                    documentTemplates,
                    documentStatuses
                });
            }))
            .then(res => { this.getStudentDocumentRequests(); })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch languages, document types or templates');
            });
    }

    getStatusCertificateId() {
        const { documentTypes } = this.state;
        const selected = documentTypes.find(el => el.text === 'Statusna potvrda');
        if (selected && selected.id) return selected.id;
        return '';
    }


    getDocTemplateIdFromDocTypeId(docType) {
        const { documentTemplates } = this.state;
        const selected = documentTemplates.find(el => el.documentType.id === docType);
        if (selected && selected.id) return selected.id;
        return '';
    }

    handleInputChange(event, { name, value }) {
        if (name === 'documentType') {
            if (value !== this.getStatusCertificateId()) {
                this.setState({ certificateReason: '' });
            }
        }
        this.setState({
            [name]: value
        });
    }

    sendDocumentRequest(documentTypeId, certificateReasonId) {
        this.setState({ loading: true });
        if (!documentTypeId) {
            this.setState({
                documentTypeError: true
            });

            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        } else if (this.state.documentType === this.getStatusCertificateId() && !certificateReasonId) {
            this.setState({
                certificateReasonIdError: true, documentTypeError: false
            });
            toast(<FormattedMessage id="studentDocuments.errInputToast" />);
            return;
        }
        let docRequest = {};

        if (documentTypeId) docRequest = { ...docRequest, documentTypeId };
        if (certificateReasonId) docRequest = { ...docRequest, certificateReasonId };
        docRequest = { ...docRequest, language: this.state.language === 1 ? window.$locale === 'hr' ? 'hr' : 'bs' : 'en', studentStudyProgramId: this.props.studentStudyProgramId };

        axios.post('student-documents/create-request-for-student', { ...docRequest })
            .then(res => {
                console.log('res.data.language.id ', res.data.language.id );
                this.processRequest(
                    this.props.studentStudyProgramId,
                    res.data.documentType.id,
                    res.data.id,
                    res.data.language.id === 2 ? 'en' : window.$locale === 'hr' ? 'hr' : 'bs'
                );
            })
            .catch(err => {
                if (err.response.data === 'This document is already in queue!') {
                    toast('Zahtjev za ovaj dokument već postoji i nije obrađen.');
                } else { toast('Došlo je do greške! Zahtjev nije uspješno podnesen.'); }
            });
    }

    processed(documentRequestId) {
        axios.put(`student-documents/process-request/${documentRequestId}`)
            .then(res => {
                this.setState({ loading: false });
            })
            .catch(err => {
                console.log('Failed to process request.');
            });
    }

    processRequest(studentStudyProgramId, documentTypeId, documentRequestId, language) {
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId, documentTypeId, documentRequestId, issueDate, language, withLogo: false
        };

        axios({
            method: 'post',
            url: '/documents/requested',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    toast('Došlo je do greške! Zahtjev nije obrađen zbog nedostatka podataka.');
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                this.processed(documentRequestId);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    getWithdrawalForm(studentStudyProgramId) {
        let issueDate = moment(new Date()).format();
        let obj = {
            studentStudyProgramId, issueDate, language: window.$locale, withLogo: false
        };
        axios({
            method: 'post',
            url: '/documents/withdrawal-form',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    toast('Došlo je do greške! Zahtjev nije obrađen zbog nedostatka podataka.');
                    console.log('tu4');
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    graduationCerificate(ids, studyCycle) {
        let issueDate = moment(new Date()).format();
        const params = {
            language: this.state.language === 1 ? window.$locale === 'hr' ? 'hr' : 'bs' : 'en', ids, issueDate, studyCycle, withLogo: false
        };
        axios({
            method: 'post',
            url: '/graduation-documents/print-completed-study-cycle-certificate',
            responseType: 'blob',
            data: { ...params }
        })
            .then(res => {
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => toast('Došlo je do greške! Zahtjev nije obrađen.'));
    }


    render() {
        return (
            <div>
                <Fragment>
                    <Segment.Group secondary>
                        <Segment clearing secondary>
                            <Form noValidate>
                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>  Tip potvrde</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Izaberite tip potvrde"
                                            value={this.state.documentType}
                                            onChange={this.handleInputChange}
                                            name="documentType"
                                            // options={(this.props.locked) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : (this.props.studyProgramStudentSwitchedToId !== null) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : (this.props.droppedOut) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : this.state.documentTypes.filter(el => el.text === 'Statusna potvrda' || el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)')}
                                            options={(this.props.locked && !this.props.studentCertificate) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : (this.props.studyProgramStudentSwitchedToId !== null) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : (this.props.studentCertificate && this.props.droppedOut) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)' || el.text === 'Ispisnica') : (this.props.droppedOut) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : (this.props.studentCertificate && this.props.graduationDate) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)' || el.text === 'Uvjerenje o završenom ciklusu studija') : (this.props.graduationDate) ? this.state.documentTypes.filter(el => el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)') : this.state.documentTypes.filter(el => el.text === 'Statusna potvrda' || el.text === 'Prepis ocjena' || el.text === 'Prepis ocjena (po godinama studija)')}
                                            search
                                            fluid
                                            selection
                                            error={this.state.documentTypeError}
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>  <FormattedMessage id="common.language" /></label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder={<FormattedMessage id="studentDocuments.selectLanguage" />}
                                            value={this.state.language}
                                            onChange={this.handleInputChange}
                                            name="language"
                                            options={this.state.documentLanguages}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field required disabled={this.state.documentType !== this.getStatusCertificateId()}>
                                        <label>  Statusna potvrda</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Izaberite statusnu potvrdu"
                                            value={this.state.certificateReason}
                                            onChange={this.handleInputChange}
                                            name="certificateReason"
                                            options={this.state.certificateReasons}
                                            search
                                            fluid
                                            selection
                                            error={this.state.certificateReasonIdError}
                                        />
                                    </Form.Field>
                                </Form.Group>
                                {this.props.studentCertificate === false ? <Button basic="true" color="blue" floated="right" onClick={this.props.closeGetRequestMode}>Odustani</Button> : null}
                                {this.state.documentType !== 5 && this.state.documentType !== 4 ?
                                    <Button
                                        disabled={localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                        color="blue"
                                        floated="right"
                                        loading={this.state.loading}
                                        onClick={
                                            () => {
                                                this.sendDocumentRequest(
                                                    this.state.documentType,
                                                    this.state.certificateReason,
                                                );
                                            }
                                        }
                                    >
                                        Štampanje
                                    </Button>
                                    :
                                    this.state.documentType === 5 ? <Button
                                        disabled={localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                        color="blue"
                                        floated="right"
                                        onClick={
                                            () => {
                                                this.getWithdrawalForm(JSON.parse(localStorage.getItem('student')).id);
                                            }
                                        }
                                    >
                                        Štampanje
                                    </Button> :
                                        <Button
                                            disabled={localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                            color="blue"
                                            floated="right"
                                            onClick={
                                                () => {
                                                    this.graduationCerificate([JSON.parse(localStorage.getItem('student')).id], JSON.parse(localStorage.getItem('student')).studyCycleId);
                                                }
                                            }
                                    >
                                            Štampanje
                                    </Button>
                                }

                            </Form>
                        </Segment>
                        <ToastContainer hideProgressBar />
                    </Segment.Group>
                </Fragment>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/CertificateRequest/GetCertificate.js